export const SEARCH_ENDPOINT = 'api/app/merchants';

/**
 * Representa a solicitação de busca de estabelecimentos.
 */
export type SearchMerchantsRequest = {
  latitude: number;
  longitude: number;
  delivery_type: number;
  page?: number;
  per_page?: number;
  search?: string;
};

/**
 * Estabelecimento retornado pela API de busca.
 */
export type SearchMerchant = {
  id: string;
  name: string;
  description: string;
  is_open: boolean;
  image: string;
  cover?: string;
  slug: string;
  min_order_price: string;
  rating: string;
  delivery_time: string;
  delivery_charge: number;
  price_range: string;
  is_favorited: boolean;
  delivery_type: number; // 1=delivery, 2=pickup, 3=both
};

/**
 * Resposta da busca de estabelecimentos com paginação.
 */
export type SearchMerchantsResponse = {
  data: SearchMerchant[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  has_more: boolean;
};
